import React, { useState } from 'react'
import moment from 'moment'
import more from './images/instagram/instagram_more.svg'
import share from './images/instagram/instagram_share.svg'
import mute from './images/instagram/instagram_mute.svg'

export default function SocialInstagramPreview({ account, startDate, content, images = [], video = false }) {
    const [imageIndex, setImageIndex] = useState(0)
    const now = moment(startDate)
    return (
        <div style={{ width: 376, backgroundColor: 'white', fontFamily: 'inter', borderRadius: '8px' }}>
            {/* header */}
            <div style={{ padding: '11px 15px 11px 10px', display: 'flex', alignItems: 'center' }}>
                <img src={account.image} style={{ height: 32, width: 32, marginRight: 10, borderRadius: '50%' }} />
                <div style={{ fontSize: '13px', fontWeight: '600', lineHeight: '18px', flexGrow: 1 }}>
                    {account.name}
                </div>
                <img src={more} />
            </div>

            {/* image */}
            {!!images.length && (
                <div style={{ position: 'relative' }}>
                    <img
                        src={images[imageIndex].url || images[imageIndex]}
                        style={{
                            backgroundColor: '#e0e0e0',
                            width: '100%',
                            position: 'relative',
                            justifyContent: 'center'
                        }}
                    />
                    {video && (
                        <div
                            style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                top: 0,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-end'
                            }}
                        >
                            <img src={mute} style={{ margin: '12px' }} />
                        </div>
                    )}
                </div>
            )}
            {images.length > 1 && (
                // centered dots, clickable that updates the imageIndex
                <div
                    style={{
                        padding: '8px 0',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    {images.map((img, index) => (
                        <div
                            key={index}
                            onClick={() => setImageIndex(index)}
                            style={{
                                height: 6,
                                width: 6,
                                borderRadius: '50%',
                                backgroundColor: index === imageIndex ? '#5950FB' : '#E1E1E0',
                                margin: '0 2px',
                                cursor: 'pointer'
                            }}
                        ></div>
                    ))}
                </div>
            )}

            {/* content */}
            <div style={{ padding: '16px' }}>
                <img src={share} />
                <div
                    style={{
                        color: '#262626',
                        fontSize: '13px',
                        fontWeight: '600',
                        lineHeight: '18px',
                        marginBottom: 6
                    }}
                >
                    1,337 likes
                </div>
                <div
                    style={{
                        color: '#262626',
                        fontSize: '12px',
                        fontWeight: '400',
                        lineHeight: '16px',
                        marginBottom: 6,
                        maxHeight: '32px',
                        overflow: 'hidden',
                        wordWrap: 'break-word',
                        textOverflow: '... more',
                        wordBreak: 'break-all'
                    }}
                >
                    <span style={{ fontWeight: 600 }}>{account.name} </span>
                    <span dangerouslySetInnerHTML={{ __html: content }}></span>
                </div>
                <div
                    style={{ color: 'rgba(0, 0, 0, 0.40)', fontSize: '11px', fontWeight: 400, letterSpacing: '0.05px' }}
                >
                    {now.format('DD MMMM')}
                </div>
            </div>
        </div>
    )
}
